import { render } from "./ProjectUserDetail.vue?vue&type=template&id=f34bb5d2"
import script from "./ProjectUserDetail.vue?vue&type=script&lang=js"
export * from "./ProjectUserDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__